import styled from "styled-components";

export const Container = styled.div`
  width: ${(props) => props.width || "300px"};
  height: ${(props) => props.height || "auto"};
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.objectFit || "cover"};
  object-position: center;
  display: block;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;

  &::before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 20px;

  &::before {
    content: "📷";
    display: block;
    font-size: 24px;
    margin-bottom: 8px;
  }
`;
